// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ArrowDownOutlinedSvg from "@ant-design/icons-svg/es/asn/ArrowDownOutlined";
import AntdIcon from '../components/AntdIcon';

var ArrowDownOutlined = function ArrowDownOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ArrowDownOutlinedSvg
  }));
};

ArrowDownOutlined.displayName = 'ArrowDownOutlined';
export default React.forwardRef(ArrowDownOutlined);